import UYouData from './index.vue';

export {
    UYouData,
};

export default UYouData;
